import * as React from 'react';
import classNames from 'classnames';
import { ConfigContext, withConfigProvider } from '../config-provider';
import warning from 'antd/es/_util/warning';
import { PresetColorTypes, PresetStatusColorTypes } from '../_util/colors';
const PresetStatusColorRegex = new RegExp(`^(${PresetStatusColorTypes.join('|')})$`);
const PresetColorRegex = new RegExp(`^(${PresetColorTypes.join('|')})(-inverse)?$`);
const CheckableTag = (props) => {
    const { prefixCls: customizePrefixCls, size, className, checked, children, disabled = 'false', onChange, onClick, type, style, rounded, color, ...restProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('tag', customizePrefixCls);
    const spanRef = React.useRef();
    if (process.env.NODE_ENV !== 'production')
        warning(!('theme' in props), 'Tag', '`theme` is depreacted in B-Design 3.0');
    let tagColor = !color ? '' : color.toLocaleLowerCase().replace(/\s/g, '-');
    const isPresetColor = () => {
        if (!color) {
            return false;
        }
        return PresetColorRegex.test(tagColor) || PresetStatusColorRegex.test(tagColor) || tagColor === 'white';
    };
    const presetColor = isPresetColor();
    const cls = classNames(prefixCls, {
        [`${prefixCls}-checkable`]: true,
        [`${prefixCls}-checkable-checked`]: checked,
        [`${prefixCls}-disabled`]: disabled === true,
        [`${prefixCls}-xs`]: size === 'xs',
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-outline`]: type === 'outline',
        [`${prefixCls}-solid`]: type === 'solid',
        [`${prefixCls}-rounded`]: rounded,
        [`${prefixCls}-${tagColor}`]: presetColor
    }, className);
    const handleClick = (e) => {
        onChange?.(!checked);
        onClick?.(e);
    };
    return (React.createElement("span", { ref: spanRef, className: cls, onClick: handleClick, style: { position: 'relative', ...style }, ...restProps },
        children,
        React.createElement("i", { className: `${prefixCls}-diagonal-line` }),
        React.createElement("i", { className: `${prefixCls}-folded-corner` })));
};
export default withConfigProvider(CheckableTag);
